require('hammerjs'); // importing hammer.js
require('jquery-mousewheel'); // importing jquery-mousewheel

require('./scss/framway.scss');
require('./js/framway.js');
app.loadComponents([
  'modalFW',
  'tabs',
  'goto',
  'foldingbox',
  'block-std',
  'block-img',
  'sliderFW',
  'btn-load',
  'select2FW',
  'filters',
  'guideline',
]);
console.log(app);
$(function () {
  $('.account-toggle').on('click',function(){
    $(this).toggleClass('active');
    $('#header .mod_login').toggleClass('active');
  });
  $('body').on('click',function(e){
    if(!$(e.target).closest('.mod_login,.account-toggle').length && !$(e.target).hasClass('mod_login')  && !$(e.target).hasClass('account-toggle')){
      $('#header .mod_login,.account-toggle').removeClass('active');
    }
  });

  $(window).resize(function(){
    $('.mod_exam_reader .slide.slide-0').css('min-height', viewport.height - $('#header').outerHeight());
    $('.mod_exam_reader .slide').not('.slide-0')
      .css('min-height', viewport.height - $('.mod_exam_reader .status').outerHeight() - $('#header').outerHeight())
      .css('margin-bottom', $('.mod_exam_reader .status').outerHeight());
  }).trigger('resize');


  $('.strTC').each(function(){
    $(this).css('background-color',utils.stringToColor($(this).text()));
  })
});

app.check403 = function(jqXHR, textStatus){
  if("timeout" == textStatus)
    notif_fade.error("Erreur de communication avec le serveur.");
  else if(jqXHR.status == 403){
    notif_fade.error("Vous avez été déconnecté, la page va se rafraichir et vous devrez vous reconnecter.");
    setTimeout(function(){ location.reload(); }, 3000);
  }
  else
    notif.error("Erreur : " + textStatus);
}



// WEBPACK FOOTER //
// ./src/index.js